module.exports = __webpack_public_path__ + "img/empty.027d4b80.svg";